// src/utils/snakeToCamel.ts

/**
 * Converts snake_case string to camelCase.
 */
export function snakeToCamel(str: string): string {
  return str.replaceAll(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

/**
 * Recursively converts all object keys from snake_case to camelCase.
 * Handles arrays and nested objects.
 */
export function snakeToCamelObject(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(snakeToCamelObject);
  } else if (obj && typeof obj === 'object' && obj.constructor === Object) {
    const newObj: Record<string, any> = {};
    Object.keys(obj).forEach((key) => {
      const newKey = snakeToCamel(key);
      newObj[newKey] = snakeToCamelObject(obj[key]);
    });
    return newObj;
  }
  return obj;
}